import React from "react";
import Button from "../../components/ui/Button";

const ResearchHero = () => {
  return (
    <section className="w-full bg-white py-8 md:py-16 px-4 md:py-24">
      <div className="max-w-[1800px] mx-auto flex flex-col items-center text-center">
        {/* Heading */}
        <h1 className="text-[24px] md:text-[30px] lg:text-[40px] 2xl:text-[60px]  font-bold text-[#183076] mb-6 tracking-tight">
          Rigorous Standards for Reliable Research
        </h1>

        {/* Subtext */}
        <p className="max-w-[1100px] text-[14px] md:text-[18px] xl:text-[24px] leading-relaxed mb-10">
          ANVIYA operates under the highest ethical standards for human
          biospecimen collection and distribution, ensuring your research meets
          all regulatory requirements.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 mb-16">
          {/* <Button
            className="px-8 py-3 bg-[#183076] text-white font-semibold rounded-full hover:bg-blue-900 transition-colors shadow-md"
            text="Start RFQ Process"
            to="/rfq"
          /> */}
          <Button
            className="px-8 py-3 bg-white text-[#183076] font-semibold border-2 border-slate-200 rounded-full hover:border-[#183076] hover:text-white transition-all"
            text="View Capabilities"
            to="/biospecimens-services"
          />
        </div>

        {/* Image Container */}
        <div className="w-full rounded-2xl overflow-hidden shadow-sm border border-slate-100">
          <img
            src="/images/BiostorageImg/Biostorage.png"
            alt="Abstract cellular research visualization"
            className="w-full h-auto object-cover min-h-[300px]"
          />
        </div>
      </div>
    </section>
  );
};

export default ResearchHero;
